import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
const Acciones = ({ id }) => {
    return (
        <section className="page-section" style={{ backgroundColor: '#f1f1f1' }}>
            <div className="name-section" id={id}>
                <Container className="text-center">
                    <h2 className="mb-4">Características de cada actor en confirmae</h2>
                </Container>
                <Container>
                    <Row className="acciones-actores">
                        <Col md={4} sm={12} className="mb-3">
                            <div className="mr-1 ml-1 caja">
                                <div className="color-pagador">
                                    PAGADOR
						</div>
                                <ul>
                                    <li>Carga nóminas confirmadas</li>
                                    <li>Asocia nóminas a factoring</li>
                                    <li>Notifica a proveedores</li>
                                    <li>Seguimiento de cesiones</li>
                                    <li>Seguimiento de pagos</li>
                                    <li>Consolidado de información</li>
                                </ul>
                            </div>

                        </Col>
                        <Col md={4} sm={12} className="mb-3">
                            <div className="mr-1 ml-1 caja">
                                <div className="color-factoring">
                                    FACTORING
						</div>
                                <ul>
                                    <li>Visualiza nóminas asociadas</li>
                                    <li>Seguimiento de cesiones</li>
                                    <li>Carga de comprobantes de pago</li>
                                    <li>Consolidado de información</li>
                                </ul>
                            </div>

                        </Col>
                        <Col md={4} sm={12} className="mb-3">
                            <div className="mr-1 ml-1 caja">
                                <div className="color-proveedor">
                                    PROVEEDOR
						</div>
                                <ul>
                                    <li>Notificación de documentos a ceder</li>
                                    <li>Herramienta de cesión integrada</li>
                                    <li>Seguimiento de cesiones</li>
                                    <li>Seguimiento de pagos</li>
                                    <li>Actualiza información Bancaria</li>
                                </ul>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </div>
        </section>
    )
}

export default Acciones
